import {
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
  DrawerRootNested,
  DrawerTitle,
  DrawerTrigger,
} from 'vaul-vue'

/**
 * If you want to change the API, only this file changes.
 */
export const VDrawerRoot = DrawerRoot
export const VDrawerRootNested = DrawerRootNested
export const VDrawerTrigger = DrawerTrigger
export const VDrawerPortal = DrawerPortal
export const VDrawerOverlay = DrawerOverlay
export const VDrawerContent = DrawerContent
export const VDrawerTitle = DrawerTitle
export const VDrawerDescription = DrawerDescription
export const VDrawerClose = DrawerClose
